export default __webpack_public_path__ + "static/media/intergalacticpost_demo_image.4f8ef261.png";